import { Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { StructureSelectorComponent } from 'src/app/shared/modals/StructureSelector/structureselector.component';
import { OrganizationsService } from 'src/app/Services/organizations.service';


@Component({
    selector: 'app-editreliantconfig',
    templateUrl: './editreliantconfig.component.html',
    styleUrls: ['./editreliantconfig.component.scss'],
    standalone: false
})
export class EditReliantConfigComponent extends ModelEditor implements OnInit {
  public modalService: SimpleModalService;

  constructor(
    private apiService: ApiServiceBase, 
    private injector: Injector, 
    modalService: SimpleModalService,
    private organizationsService: OrganizationsService
  ) {
    super("integrations/reliant/configuration", injector);
    this.modalService = modalService;
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      Description: "",
      Url: "https://api.reliant.com/v1/",
      ApiKey: ""
    }
  }

  public override Validators(): any {
    return {
      Url: [Validators.maxLength(100), Validators.minLength(1), Validators.required],
      Name: [Validators.maxLength(100), Validators.minLength(1), Validators.required],
      ApiKey: [Validators.maxLength(100)],
      Description: [Validators.maxLength(200)],
    }
  }

  public override AfterModelLoaded(): void {
    return;
  }
  public override BeforeSave(): boolean | void {
    return;
  }

}
